import React from 'react';

export const CardTitle: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <h4 className="card-header-title">{children}</h4>;

export const SectionTitle: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <span className="h5">{children}</span>;

export const CardSubtitle: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => <span className="small text-secondary">{children}</span>;
